import React from 'react';
import MandatorySymbol from '../MandatorySymbol';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

interface TitleProps {
  title:string;
  mandatory:boolean;
  error:string;
  centerText:boolean;
}

const Title:React.FC<TitleProps> = ({ title, mandatory, error, centerText })=>{
  const intl = useIntl();

  return (<h2
    data-testid="title"
    className="title_card overflow-hidden flex flex-col flex-1"
    aria-label={
      mandatory
        ? `${title} - ${intl.formatMessage({ id: 'validation.required', defaultMessage: 'Please answer to continue.' })}`
        :`${title}`
    }
  >
    <span className={classNames('break-word', { 'm-auto text-center': centerText })}>
      {mandatory && <MandatorySymbol className="mr-1" />}
      {title}
    </span>
    {error && (
      <span className={classNames('text-danger-high px-1 text-xs! font-normal block', { 'm-auto text-center': centerText })}>
        {error}
      </span>
    )}
  </h2>);
};

export default Title;